"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const string_utils_1 = require("@/common/string_utils");
function default_1() {
    const customDeliveries = (0, react_redux_1.useSelector)((state) => state.roomData.deliveries).filter((delivery) => delivery.delivery_type === 6);
    const dispatch = (0, react_redux_1.useDispatch)();
    const setDeliveryId = (deliveryId) => {
        dispatch((0, roomViewStore_1.setCustomDeliveryId)(deliveryId));
    };
    const customDeliveryId = (0, react_redux_1.useSelector)((state) => state.customDeliveryId);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(components_1.NativeSelect, Object.assign({ value: customDeliveryId, onChange: e => setDeliveryId(Number(e.target.value)), sx: {
            height: '40px',
            p: '0 16px',
            border: '1px solid rgba(0, 0, 0, 0.15) !important',
            borderRadius: '2px',
            mb: '6px',
            fontSize: '15px',
            '.MuiNativeSelect-icon': { right: '16px', width: '24px', height: '24px' },
        } }, { children: [(0, jsx_runtime_1.jsxs)("option", Object.assign({ value: "", disabled: true }, { children: ["\uD83D\uDE9A\u00A0\u00A0", `${t('배송방법 선택')}`] })), customDeliveries.map((delivery, idx) => {
                const { id: deliveryId, name, delivery_price } = delivery;
                return ((0, jsx_runtime_1.jsx)("option", Object.assign({ value: deliveryId }, { children: `${name} (${(0, string_utils_1.money)(Number(delivery_price))}${t('원')})` }), `custom_delivery_select_${deliveryId}_${idx}`));
            })] })));
}
exports.default = default_1;
